import Modal from "../../../../parts/modal-new";
import VideoUpload from "../components/VideoUpload";

const id = "modal-add-welcome-video";
const form = "add-welcome-video";

const WelcomeVideo = ({ workflow }) => {
  return (
    <form
      action="/actions/getting-started/video"
      method="POST"
      encType="multipart/form-data"
      data-noreset
      id={form}
    >
      <input type="hidden" name="option" value="welcomeVideo" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title="Add Welcome Video"
        className="getting-started-video narrow"
      >
        <div className="body">
          <VideoUpload
            form={form}
            video={workflow.options.welcomeVideo?.video}
          />
        </div>

        <footer className="foot">
          <button data-button-type="primary" type="submit">
            Add Video
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default WelcomeVideo;
